import React from 'react'

interface LinkTextProps {
  to?: string,
  children?: React.ReactNode,
  title?: string
}

const LinkText = (props: LinkTextProps) => {
  const { to = "#", title = "", children } = props
  return (
    <a data-testid="link-text" href={to} target="_blank" title={title} rel="noopener noreferrer" className="links">
      {children}
    </a>
  );
}

export default LinkText